import { router } from '../util/router'

let mobileMenu = null
let menuToggler = null

function showMenu() {
  // Lock the scroll on body
  // and show the menu
  $('body').addClass('overflow-hidden')
  mobileMenu.slideDown('medium', function () {
    // Switch the icons
    menuToggler.find('.opened').show();
    menuToggler.find('.closed').hide();

    // Add the open class
    mobileMenu.addClass('open')
  })
}

function hideMenu() {
  // Lock the scroll on body
  // and show the menu
  $('body').removeClass('overflow-hidden')
  mobileMenu.slideUp('medium', function () {
    // Switch the icons
    menuToggler.find('.opened').hide();
    menuToggler.find('.closed').show();

    // Remove the open class
    mobileMenu.removeClass('open')
  })
}

router.on('common', 'init', () => {
  mobileMenu = $('#mobile-menu')
  menuToggler = $('#mobile-menu-toggler')

  $(menuToggler).on('click', function () {
    mobileMenu.hasClass('open') ? hideMenu() : showMenu()
  })
})



// WEBPACK FOOTER //
// ./scripts/components/mobile-menu.js